import api from "./api";

export interface Credencial {
  id: number;
  url: string;
  usuario: string;
  detalhes?: string;
  senha?: string; // A senha é opcional no retorno da listagem
  createdAt: string;
  updatedAt: string;
}

export interface CreateCredencialDTO {
  url: string;
  usuario: string;
  senha: string;
  detalhes?: string;
}

export interface UpdateCredencialDTO {
  url?: string;
  usuario?: string;
  senha?: string;
  detalhes?: string;
}

const listar = async (): Promise<Credencial[]> => {
  const { data } = await api.get<Credencial[]>('/credenciais');
  return data;
};

const criar = async (credencialData: CreateCredencialDTO): Promise<Credencial> => {
  const { data } = await api.post<Credencial>('/credenciais', credencialData);
  return data;
};

const atualizar = async (id: number, credencialData: UpdateCredencialDTO): Promise<Credencial> => {
  const { data } = await api.put<Credencial>(`/credenciais/${id}`, credencialData);
  return data;
};

const deletar = async (id: number): Promise<void> => {
  await api.delete(`/credenciais/${id}`);
};

export const credencialService = {
  listar,
  criar,
  atualizar,
  deletar,
};